export default "__VITE_ASSET__pjSHlKzm__"